function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-section-id]');

  sections.forEach(section => {
    const sectionId = section.dataset.sectionId;
    if (!section.classList.contains('jv-carousel-creators')) return;

    const categoryTabs = section.querySelectorAll('.jv-tab-button');
    const categoryTabsContainer = section.querySelector('.jv-category-tabs');
    const scrollIndicator = section.querySelector(`#jv-scroll-indicator-${sectionId}`);
    const creatorsContainer = section.querySelector('.jv-creators-carousel');
    const creatorNavLeft = section.querySelector('.jv-creator-nav-left');
    const creatorNavRight = section.querySelector('.jv-creator-nav-right');
    const sectionPrevBtn = section.querySelector('.jv-section-prev');
    const sectionNextBtn = section.querySelector('.jv-section-next');
    const creatorItems = section.querySelectorAll('.jv-creator-item');
    const collectionCarousels = section.querySelectorAll('.jv-collection-carousel');
    const creatorButton = section.querySelector(`#jv-creator-button-${sectionId}`);

    const loadingSkeleton = section.querySelector(`#jv-carousel-loading-${sectionId}`);

    const firstVisibleCreator = section.querySelector('.jv-creator-item:not([style*="display: none"])');
    let currentCategory = firstVisibleCreator ? firstVisibleCreator.dataset.creatorCategory : '';
    let activeCreatorIndex = 0;
    let ticking = false;

    function sortCarouselByPrice(carousel) {
      const slides = Array.from(carousel.querySelectorAll('.resource-list__slide'));
      if (slides.length <= 1) return;
      const parent = slides[0].parentElement;
      slides.sort((a, b) => {
        const priceA = parseInt(a.querySelector('.jv-product-item')?.dataset.price ?? 0);
        const priceB = parseInt(b.querySelector('.jv-product-item')?.dataset.price ?? 0);
        return priceA - priceB;
      });
      slides.forEach(slide => parent.appendChild(slide));
    }

    function revealCarousels() {
      if (loadingSkeleton) {
        loadingSkeleton.classList.add('hidden');
      }
    }

    function updateNavButtonsState() {
      if (!sectionPrevBtn || !sectionNextBtn) return;

      const activeTab = section.querySelector('.jv-tab-button.active');
      if (!activeTab) return;

      const index = Array.from(categoryTabs).indexOf(activeTab);

      if (index <= 0) {
        sectionPrevBtn.setAttribute('disabled', 'true');
      } else {
        sectionPrevBtn.removeAttribute('disabled');
      }

      if (index >= categoryTabs.length - 1) {
        sectionNextBtn.setAttribute('disabled', 'true');
      } else {
        sectionNextBtn.removeAttribute('disabled');
      }
    }

    function updateScrollIndicator() {
      if (!categoryTabsContainer || !scrollIndicator) return;

      const containerWidth = categoryTabsContainer.clientWidth;
      const scrollWidth = categoryTabsContainer.scrollWidth;
      const scrollLeft = categoryTabsContainer.scrollLeft;

      if (scrollWidth <= containerWidth + 2) {
        scrollIndicator.style.opacity = '0';
        ticking = false;
        return;
      } else {
        scrollIndicator.style.opacity = '1';
      }

      const indicatorWidthRatio = containerWidth / scrollWidth;
      const indicatorWidth = containerWidth * indicatorWidthRatio;

      const maxScroll = scrollWidth - containerWidth;
      if (maxScroll <= 0) {
        scrollIndicator.style.opacity = '0';
        ticking = false;
        return;
      }

      const scrollPercentage = scrollLeft / maxScroll;

      scrollIndicator.style.width = `${indicatorWidthRatio * 100}%`;
      scrollIndicator.style.transform = `translateX(${scrollPercentage * (containerWidth - indicatorWidth)}px)`;

      ticking = false;
    }

    if (sectionPrevBtn && sectionNextBtn && categoryTabs.length > 0) {

      sectionPrevBtn.addEventListener('click', () => {
        const activeTab = section.querySelector('.jv-tab-button.active');
        const index = Array.from(categoryTabs).indexOf(activeTab);

        if (index > 0) {
          const prevTab = categoryTabs[index - 1];
          prevTab.click();
          prevTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });

      sectionNextBtn.addEventListener('click', () => {
        const activeTab = section.querySelector('.jv-tab-button.active');
        const index = Array.from(categoryTabs).indexOf(activeTab);

        if (index < categoryTabs.length - 1) {
          const nextTab = categoryTabs[index + 1];
          nextTab.click();
          nextTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });

      categoryTabs.forEach(tab => {
        tab.addEventListener('click', () => {
          requestAnimationFrame(updateNavButtonsState);
        });
      });

      updateNavButtonsState();
    }

    if (categoryTabsContainer && scrollIndicator) {
      categoryTabsContainer.addEventListener('scroll', function () {
        if (!ticking) {
          requestAnimationFrame(updateScrollIndicator);
          ticking = true;
        }
      }, { passive: true });
      requestAnimationFrame(updateScrollIndicator);
    }

    function filterCreatorsByCategory(category) {
      creatorItems.forEach(item => {
        const creatorCategory = item.dataset.creatorCategory;

        if (category === 'all' || creatorCategory === category) {
          item.style.display = 'flex';
        } else {
          item.style.display = 'none';
        }
      });

      collectionCarousels.forEach(carousel => {
        const collectionCategory = carousel.dataset.collectionCategory;
        if (category === 'all' || collectionCategory === category) {
          carousel.style.display = 'block';
        } else {
          carousel.style.display = 'none';
        }
      });

      const firstVisibleCreator = Array.from(creatorItems).find(item => {
        const style = item.getAttribute('style') || '';
        const isVisible = !style.includes('display: none');
        const creatorCategory = item.dataset.creatorCategory;
        const isCategoryMatch = category === 'all' || creatorCategory === category;
        return isVisible && isCategoryMatch;
      });

      if (firstVisibleCreator) {
        creatorItems.forEach(item => item.setAttribute('data-active', 'false'));
        firstVisibleCreator.setAttribute('data-active', 'true');

        const collectionIndex = parseInt(firstVisibleCreator.dataset.collectionIndex);
        activeCreatorIndex = collectionIndex;
        showCollectionCarousel(collectionIndex);
        updateCreatorButton(firstVisibleCreator);
      }
    }

    categoryTabs.forEach(tab => {
      tab.addEventListener('click', function () {
        categoryTabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        currentCategory = this.dataset.category;
        filterCreatorsByCategory(currentCategory);
        updateNavButtonsState();
      });
    });

    function showCollectionCarousel(index) {
      collectionCarousels.forEach((carousel, i) => {
        if (i === index) {
          carousel.style.display = 'block';
        } else {
          carousel.style.display = 'none';
        }
      });
    }

    function updateCreatorButton(creatorItem) {
      if (!creatorButton) return;

      const creatorNameElement = creatorItem.querySelector('.jv-creator-name');
      const creatorName = creatorNameElement ? creatorNameElement.textContent.trim() : 'Criador';

      const buttonTemplate = creatorButton.dataset.template || 'Ver a loja do {player}';
      const newButtonText = buttonTemplate.replace('{player}', creatorName);
      creatorButton.textContent = newButtonText;

      const creatorUrl = creatorItem.dataset.creatorUrl;
      if (creatorUrl && creatorUrl !== '') {
        creatorButton.href = creatorUrl;
      } else {
        creatorButton.href = '#';
      }
    }

    if (creatorsContainer) {
      creatorsContainer.addEventListener('click', function (e) {
        const creatorItem = e.target.closest('.jv-creator-item');
        if (!creatorItem) return;

        const collectionIndex = parseInt(creatorItem.dataset.collectionIndex);

        creatorItems.forEach(creator => creator.setAttribute('data-active', 'false'));
        creatorItem.setAttribute('data-active', 'true');

        activeCreatorIndex = collectionIndex;
        showCollectionCarousel(collectionIndex);
        updateCreatorButton(creatorItem);
      });
    }

    if (creatorNavLeft && creatorNavRight && creatorsContainer) {
      creatorNavLeft.addEventListener('click', () => {
        creatorsContainer.scrollBy({ left: -150, behavior: 'smooth' });
      });

      creatorNavRight.addEventListener('click', () => {
        creatorsContainer.scrollBy({ left: 150, behavior: 'smooth' });
      });
    }

    // Ordenar todos os carrosséis por preço ANTES de exibir qualquer um
    collectionCarousels.forEach(carousel => sortCarouselByPrice(carousel));

    if (categoryTabs.length > 0) {
      const existingActiveTab = section.querySelector('.jv-tab-button.active');
      if (existingActiveTab) {
        const activeCategory = existingActiveTab.dataset.category;
        currentCategory = activeCategory;
        filterCreatorsByCategory(activeCategory);
      } else if (categoryTabs[0]) {
        categoryTabs[0].classList.add('active');
        currentCategory = categoryTabs[0].dataset.category;
        filterCreatorsByCategory(currentCategory);
      }
      updateNavButtonsState();
    } else {
      const firstCreator = Array.from(creatorItems).find(item =>
        parseInt(item.dataset.collectionIndex) === 0
      );

      if (firstCreator && firstCreator.getAttribute('data-active') !== 'true') {
        creatorItems.forEach(item => item.setAttribute('data-active', 'false'));
        firstCreator.setAttribute('data-active', 'true');
        updateCreatorButton(firstCreator);
      }

      if (collectionCarousels.length > 0) {
        showCollectionCarousel(0);
      }

      if (creatorItems.length > 0 && creatorButton && !firstCreator) {
        updateCreatorButton(creatorItems[0]);
      }
    }

    revealCarousels();
  });
});